module.exports = __webpack_public_path__ + "img/corto-maltese.c817ff51.jpg";